import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { filter, map, tap } from 'rxjs/operators';

@Injectable()
export class ResetPasswordGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate() {
    return this.authService.resetCode$.pipe(
      filter(res => res !== null),
      tap(res => {
        if (!res) {
          this.router.navigate(['']);
        }
      }),
      map(res => !!res)
    );
  }
}
